import { render } from "./module-box.vue?vue&type=template&id=05980714"
import script from "./module-box.vue?vue&type=script&lang=js"
export * from "./module-box.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/module-box.vue'],['render',render],['__file',"module-box.vue"]])

export default __exports__